import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

export class ProductAvailability extends Component {
  #abortController = new AbortController();

  connectedCallback() {
    super.connectedCallback();
    const target = this.closest('product-card, .shopify-section, dialog');
    target?.addEventListener(ThemeEvents.variantUpdate, this.#update, { signal: this.#abortController.signal });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#abortController.abort();
    this.#abortController = new AbortController();
  }

  #update = (event) => {
    const { data } = event.detail;
    if (!data.newProduct && String(data.productId) !== this.dataset.productId) return;

    const productId = data.newProduct?.id ?? this.dataset.productId;
    const selector = `product-availability[data-product-id="${productId}"][data-badge-context="${this.dataset.badgeContext}"]`;
    const updated = data.html.querySelector(selector);
    if (!updated) return;
    morph(this, updated, { childrenOnly: true });
    this.hidden = updated.hasAttribute('hidden');
    this.dataset.productId = String(productId);
  };
}

if (!customElements.get('product-availability')) {
  customElements.define('product-availability', ProductAvailability);
}
